module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAADCAYAAAAwcknoAAAABHNCSVQICAgIfAhkiAAAAFpJREFUKFPl0EENgDAQRNG/CkDCkhRfOAAJxUGRUF00oVWyHEhTPOzc5vif3GgU2EFm3M6uQD16/jAhS2Exty4jvAUe7fdn0qSgCWQDJq9Qhp0rNQ6gz8Sw9AKWFBjorcwCxwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/update/nav_hover.png
// module id = 1188
// module chunks = 41